// frontend/src/api/expenses.ts
import api from './axios';
import {
    Expense,
    CreateExpenseRequest,
    UpdateExpenseRequest
} from '../types/expense';

export async function getExpenses(fiscalYear: number): Promise<Expense[]> {
    const res = await api.get<Expense[]>('/expenses', { params: { fiscalYear } });
    return res.data;
}

export async function createExpense(
    data: CreateExpenseRequest
): Promise<Expense> {
    const res = await api.post<Expense>('/expenses', data);
    return res.data;
}

export async function updateExpense(
    id: string,
    data: UpdateExpenseRequest
): Promise<Expense> {
    const res = await api.patch<Expense>(`/expenses/${id}`, data);
    return res.data;
}

export async function deleteExpense(id: string): Promise<void> {
    await api.delete(`/expenses/${id}`);
}
